module.exports = __webpack_public_path__ + "static/img/dtqk.e6b3a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dtqk.png
// module id = FZsZ
// module chunks = 9